import { render, staticRenderFns } from "./stepUi.vue?vue&type=template&id=ce0dcab4&scoped=true&"
import script from "./stepUi.vue?vue&type=script&lang=js&"
export * from "./stepUi.vue?vue&type=script&lang=js&"
import style0 from "./stepUi.vue?vue&type=style&index=0&id=ce0dcab4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce0dcab4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ce0dcab4')) {
      api.createRecord('ce0dcab4', component.options)
    } else {
      api.reload('ce0dcab4', component.options)
    }
    module.hot.accept("./stepUi.vue?vue&type=template&id=ce0dcab4&scoped=true&", function () {
      api.rerender('ce0dcab4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taskMgr/newTemplateMgr/components/patrolTemplate/quickPatrolRecordType/stepUi.vue"
export default component.exports